var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearchPrimary2020 = function SvgSearchPrimary2020(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#669AFF",
    fillRule: "evenodd",
    d: "M13.817 8.75a5.067 5.067 0 1 1-10.134 0 5.067 5.067 0 0 1 10.134 0m-.979 5.267a6.667 6.667 0 1 1 1.179-1.179l3.841 3.842-1.178 1.178z",
    clipRule: "evenodd"
  })));
};
export default SvgSearchPrimary2020;